import { getQueryMarkup } from './getQuery';

/**
 *
 * @param {array} post_slugs - array of post_slugs
 * @param {number} page - page number
 * @param {number} numPosts - number of posts
 * @param {'teaser_partner_more_grid' | 'index_item'} markupType - markup type to use
 * @return {Promise<*>}
 */
export async function getPostsMarkup( post_slugs, page, numPosts, markupType ) {

    const queryObj = {
        "is_logged_in": jQuery( 'body' ).hasClass( 'logged-in' ),
        "orderby": "date",
        "order": "DESC",
        "post_type": post_slugs,
        "page": page,
        "offset": page * numPosts,
        "posts_per_page": numPosts
    };

    const queryParam = encodeURIComponent(JSON.stringify(queryObj));

    try {

        const res = await getQueryMarkup( queryParam, markupType ); 
        const body = await res.json();

        return body.markup;

    } catch (e) {

        console.error('Developer message: Error in fetching markup with post data: ' + e);

        throw e;

    }

}

/**
 *
 * @param post_ids - array of post_ids
 * @param markup
 * @return {Promise<string>}
 */
export async function getPostsMarkupByIDs( post_ids, markup ) {

    const queryObj = {
        "post__in": post_ids
    };

    const queryParam = encodeURIComponent(JSON.stringify(queryObj));

    try {

        const res = await getQueryMarkup( queryParam, markup );
        const body = await res.json();
        return body.markup;

    } catch (e) {

        console.error('Developer message: Error in fetching markup with post data: ' + e);

        throw e;

    }

}
